import { getAxiosAPIInstance } from "./config";

const client = getAxiosAPIInstance();

export const getHSCodeStatic = async () => {
  try {
    const { data } = await client.get("/hs-codes/static");
    return data
  } catch (err) {
    throw err;
  }
};

export const searchHSCode = async (query, country) => {
  if (!query) return [];

  try {
    const { data } = await client.get("/hs-codes/search", {
      params: { query, country },
    });
    return data;
  } catch (err) {
    throw err;
  }
};
